import { FILE_QUESTION_TYPES } from "../../components/activityQuestions/utils/questionTypes";
import { generateFilesFromActivityQuestions } from "../../utils/generateFilesForUploadFromActivityQuestions";

/**
 * Checks if a follow-up has file/sketch questions with actual file values
 */
export const hasFileQuestions = (questionObj) => {
    if (!questionObj || !questionObj.mappedQuestions) {
        return false;
    }

    return questionObj.mappedQuestions.some((q) => FILE_QUESTION_TYPES.includes(q.questionType) && Array.isArray(q.value) && q.value.length > 0);
};

/**
 * Finds the question object for a given UUID
 */
export const getQuestionsByUuid = (uuid, activityQuestionsUuids) => {
    return activityQuestionsUuids?.[uuid] || null;
};

/**
 * Creates an upload payload for a single follow-up
 */
export const createUploadPayload = (followUp, activityQuestionsUuids, userName) => {
    const uuid = followUp.uuid;
    const questionObj = getQuestionsByUuid(uuid, activityQuestionsUuids);

    if (!questionObj || !hasFileQuestions(questionObj)) {
        return null;
    }

    return {
        filesPayload: generateFilesFromActivityQuestions(activityQuestionsUuids, {
            uuid,
            followUpId: followUp.referenceTicketNumber,
            userName,
        }),
        followUpId: followUp.referenceTicketNumber,
    };
};

/**
 * Filters follow-ups to only those with UUIDs
 */
export const getFollowUpsWithUuids = (createdFollowUpList) => {
    return createdFollowUpList.filter((followUp) => followUp?.uuid);
};

/**
 * Main function that builds upload payloads for follow-ups with file attachments
 */
export const buildFollowUpUploadPayloads = (createdFollowUpList = [], activityQuestionsUuids = {}, userName) => {
    if (!createdFollowUpList.length) {
        return [];
    }

    const followUpsWithUuids = getFollowUpsWithUuids(createdFollowUpList);

    return followUpsWithUuids.map((followUp) => createUploadPayload(followUp, activityQuestionsUuids, userName)).filter(Boolean); // Remove null entries
};
